var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconClients = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    className,
    height = 16,
    titleId,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    className: className,
    height: height,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M5.656 15.031h6.563M7.53 3.781h6.563a.94.94 0 0 1 .937.938v6.562a.94.94 0 0 1-.937.938H3.78a.94.94 0 0 1-.937-.938v-.937H15.03M.97 6.594h4.687m5.157 8.437h-3.75l.468-2.812h2.813zM1.906.97H4.72s.937 0 .937.937v5.625s0 .938-.937.938H1.906s-.937 0-.937-.938V1.906s0-.937.937-.937"
  })));
});
export const Icon = /*#__PURE__*/React.forwardRef((_ref2, ref) => {
  let {
    className: propClassName = "",
    fill = "none",
    stroke = "currentColor",
    weight = "normal",
    height = 16,
    titleId,
    title,
    ...props
  } = _ref2;
  const className = "vector-effect-non-scaling-stroke " + propClassName;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    className: className,
    height: height,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fill: fill,
    stroke: stroke,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M5.656 15.031h6.563M7.53 3.781h6.563a.94.94 0 0 1 .937.938v6.562a.94.94 0 0 1-.937.938H3.78a.94.94 0 0 1-.937-.938v-.937H15.03M.97 6.594h4.687m5.157 8.437h-3.75l.468-2.812h2.813zM1.906.97H4.72s.937 0 .937.937v5.625s0 .938-.937.938H1.906s-.937 0-.937-.938V1.906s0-.937.937-.937"
  }));
});
export default SvgIconClients;
export const raw = __webpack_public_path__ + "static/media/IconClients.64d3cbc63047711decc2266c626220b9.svg";